import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { IoLogoRss } from 'react-icons/io5';

const RSSContainer = styled.div`
  margin-bottom: 30px;
  background: ${props => props.theme.colors.surfaceMuted};
  padding: 18px;
  border: 1px solid ${props => props.theme.colors.borderColor};
  border-radius: 16px;

  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    font-weight: 600;
    position: relative;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 10px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #333;
    transition: color 0.3s;
    
    &:hover {
      color: ${props => props.theme.colors.secondaryDark};
    }
    
    svg {
      margin-right: 8px;
      color: ${props => props.theme.colors.secondaryDark};
    }
  }
`;

const RSSFeeds = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        group(field: frontmatter___category) {
          fieldValue
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const categories = data.allMarkdownRemark.group
    .filter(group => group.fieldValue)
    .map(group => ({
      name: group.fieldValue,
      slug: group.fieldValue.toLowerCase().replace(/ /g, '-'),
    }));

  return (
    <RSSContainer>
      <h3>RSS Feeds</h3>
      <ul>
        <li>
          <a href="/rss.xml" target="_blank" rel="noopener noreferrer">
            <IoLogoRss size={16} /> All Posts
          </a>
        </li>
        {categories.map(category => (
          <li key={category.slug}>
            <a 
              href={`/category/${category.slug}/rss.xml`}
              target="_blank" 
              rel="noopener noreferrer"
            >
              <IoLogoRss size={16} /> {category.name}
            </a>
          </li>
        ))}
      </ul>
    </RSSContainer>
  );
};

export default RSSFeeds; 